import { render } from "./AppSelect.vue?vue&type=template&id=67d83f1b&scoped=true"
import script from "./AppSelect.vue?vue&type=script&lang=js"
export * from "./AppSelect.vue?vue&type=script&lang=js"

import "./AppSelect.vue?vue&type=style&index=0&id=67d83f1b&lang=scss&scoped=true"

import exportComponent from "/Users/intr0vert/Git/ai-startup/aibanner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d83f1b"]])

export default __exports__